module.exports = __webpack_public_path__ + "static/associations_2_1920-45d3d6439496d95e1b57be7ebb5b3ae5.jpg";